/** Save and open helpers for the new-task input hook. */
import { executeSaveNewTask } from '@/features/tasks/utils/mutations/newTaskStateUtils';
import { safeGenerateKeyBetween } from '@/features/tasks/utils/interactions/listKeyHelpers';

export async function saveNewTaskWithOptimisticPosition({
  taskData,
  position,
  setPosition,
  allTasks,
  user,
  augmentNewTaskWithDefaults,
  cancel,
  onAddTask,
}) {
  const currentPosition = position;

  if (
    currentPosition &&
    (currentPosition.previousKey !== undefined ||
      currentPosition.nextKey !== undefined)
  ) {
    try {
      const optimisticKey = safeGenerateKeyBetween(
        currentPosition.previousKey || null,
        currentPosition.nextKey || null,
      );
      setPosition({
        ...currentPosition,
        previousKey: optimisticKey,
      });
    } catch (e) {
      console.error('Failed to compute optimistic key', e);
    }
  }

  return executeSaveNewTask({
    taskData,
    allTasks,
    user,
    augmentNewTaskWithDefaults,
    position: currentPosition,
    _cancel: cancel,
    onAddTask,
  });
}

export function openNewTaskInputSession({
  newPos,
  key = null,
  sessionRef,
  setPosition,
  setTriggeringKey,
}) {
  if (sessionRef) sessionRef.current += 1;
  setPosition(newPos);
  setTriggeringKey(key);
}
